/**
 * Copy `text` to the clipboard, with the fallback the AI surfaces need.
 *
 * `navigator.clipboard` is undefined on insecure origins, and several
 * on-premise Flowenti installs are served over plain http:// -- without the
 * hidden-textarea + execCommand path every copy button in the app silently
 * does nothing exactly for those customers.
 *
 * Never throws: a failed copy leaves the UI as it was, and every caller shows
 * the text on screen anyway, so the user can still select it by hand.
 */
export const copyToClipboard = (text: string): void => {
  const fallback = () => {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    } catch {
      /* ignore */
    }
  };

  if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(fallback);
  } else {
    fallback();
  }
};
